import { RequestModelInterface } from "@/service/models/request-model-interface";
import { XmlDocumentWrapper } from "@/utilities/xml-helpers/xml-document-wrapper";
import { XmlElementWrapper } from "@/utilities/xml-helpers/xml-element-wrapper";
import { QueryDosage } from "../../common/query-dosage/query-dosage";

export class DosageTimeRange implements RequestModelInterface
{
    public constructor(
        public start: Date,
        public end: Date,
        public dosage: QueryDosage,
    )
    {
    }

    public isDateWithin(date: Date): boolean
    {
        return date >= this.start && date <= this.end;
    }

    /**
     * Givent any arbitrary date within this dosage, tells what is the
     * closest date of the next dose to be taken.
     * 
     * @param relativeTo        The date around which the closest dose should be searched
     */
    public getNextDoseDateFrom(relativeTo: Date): Date
    {
        return this.dosage.dosageRepeat.getClosestNextDoseDate(this.start, relativeTo);
    }

    /**
     * Givent any arbitrary date within this dosage, tells what is the
     * closest date of the previous dose taken.
     * 
     * @param relativeTo        The date around which the closest dose should be searched
     */
    public getPreviousDoseDateFrom(relativeTo: Date): Date
    {
        return this.dosage.dosageRepeat.getClosestPreviousDoseDate(this.start, relativeTo);
    }

    public getXml(doc: XmlDocumentWrapper): XmlElementWrapper
    {
        const element = doc.createElement("dosageTimeRange");

        element.appendNewElement("start", this.start.toISOString());
        element.appendNewElement("end", this.end.toISOString());

        element.append(this.dosage.getXml(doc));

        return element;
    }
}
